$.validator.addMethod('date', function(value, element, params) {
    let daySelector = params[0];
    let monthSelector = params[1];
    let yearSelector = params[2];
    let day = parseInt($(daySelector).val());
    let month = parseInt($(monthSelector).val());
    let year = parseInt($(yearSelector).val());

    if (day === 0 || month === 0 || year === 0) {
        return true;
    }

    let isValid = false;
    // Compensate for zero based index, if month was not
    // subtracted from one 0 === Jan, 1 === Feb, 2 === Mar
    month -= 1;

    // Create a new date object with the selected
    // year, month, and day values and retrieve the
    // milliseconds from it.
    let mSeconds = (new Date(year, month, day)).getTime();
    let objDate = new Date();

    // Set the time of the object to the milliseconds
    // retrieved from the original date. This will
    // convert it to a valid date.
    objDate.setTime(mSeconds);

    // Compare if the date has changed, if it has then
    // the date is not valid
    if (objDate.getFullYear() === year &&
        objDate.getMonth() === month &&
        objDate.getDate() === day) {
        isValid = true;
    }
    return isValid;
});

$.validator.addMethod('validate_email', function(email) {
    var emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegEx.test(email.trim()) === true;
});

$.validator.addMethod('valueIsNotZero', function(val) {
    return val !== '0';
});

$.validator.addMethod('phoneCountryCode', function(code) {
    const codeRegEx = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/;
    return codeRegEx.test(code) === true;
});

$.validator.addMethod('phoneNumber', function(phoneNumber) {
    const phoneNumberRegEx = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/;
    return phoneNumberRegEx.test(phoneNumber) === true && phoneNumber.length >= 4;
});

$.validator.addMethod('flightNumber', function(number) {
    const flightNumberRegEx = /(^|\b|[^a-z0-9]+|\s+)([a-z][a-z]|[a-z][0-9]|[0-9][a-z])[a-z]?[\s-]*[0-9]{1,4}[a-z]?(\s+|[^a-z0-9]+|$)/i;
    return flightNumberRegEx.test(number) === true;
});
